import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LangContext } from '../../context/LangContext';
import './style.css';

function BtnReturn({ to }) {
    const { language, translations } = useContext(LangContext);
    const headerHeight = useSelector(state => state.options.headerHeight);

    return (
        <Link to={`/${language}${to !== '' ? '/' : ''}${to}`} className="btn_page_return" style={{ top: `calc(${headerHeight}px + 21px)`}}>
            {'<'}- <span>{translations.return}</span> --
        </Link>
    );
}

export default BtnReturn;